import { Uploader } from "rsuite";
import { UploaderProps } from "rsuite";
import { FileType } from "rsuite/esm/Uploader/Uploader";

interface IFileLoader extends UploaderProps {
  fileList: FileType[];
  message?: string;
}

export function FileLoader({ fileList, message, ...rest }: IFileLoader) {
  const haveFalsyValue = fileList.some((file) => !file);

  const handleError = (reason: object, file: FileType) => {
    console.error(reason, file);
  };

  return (
    <div className="m-2">
      <Uploader
        onError={handleError}
        fileList={haveFalsyValue ? [] : fileList}
        {...rest}
        autoUpload={false}
      >
        {rest.draggable && (
          <div
            style={{
              height: 100,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <span>
              {message ? message : "Click or Drag files to this area to upload"}
            </span>
          </div>
        )}
      </Uploader>
    </div>
  );
}
